import { flatMap, range } from './util';
export function make(boxes, width, height) {
    return {
        items: boxes.map(box => makeItem(box, width, height))
    };
}
function makeItem(box, width, height) {
    return {
        id: getId(box),
        possiblePositions: allPossibleLocations(box, width, height)
            .map(points => ({ spacesTaken: new Set(points.map(point => toNumber(point, width))) }))
    };
}
function toNumber(point, width) {
    return point.y * width + point.x;
}
function getId(box) {
    for (let j = 0; j < box.height; j++) {
        for (let i = 0; i < box.width; i++) {
            if (box.squares[i][j] !== 0) {
                return box.squares[i][j];
            }
        }
    }
    return -1;
}
function coordinates(box) {
    let result = [];
    for (let j = 0; j < box.height; j++) {
        for (let i = 0; i < box.width; i++) {
            if (box.squares[i][j] !== 0) {
                result.push({ x: i, y: j });
            }
        }
    }
    return result;
}
function possibleLocations(box, width, height) {
    const offsetPoints = coordinates(box);
    let locations = [];
    for (let j = 0; j < (height - box.height) + 1; j++) {
        for (let i = 0; i < (width - box.width) + 1; i++) {
            locations.push(offsetPoints.map(({ x, y }) => ({ x: x + i, y: y + j })));
        }
    }
    return locations;
}
function allPossibleLocations(box, width, height) {
    const box90 = rotate(box);
    const box180 = rotate(box90);
    const box270 = rotate(box180);
    return flatMap([box, box90, box180, box270], x => possibleLocations(x, width, height));
}
export function rotate(box) {
    let rotatedBox = {
        height: box.width,
        width: box.height,
        squares: range(box.height).map(_ => [])
    };
    for (let j = 0; j < box.height; j++) {
        for (let i = 0; i < box.width; i++) {
            rotatedBox.squares[box.height - j - 1][i] = box.squares[i][j];
        }
    }
    return rotatedBox;
}
